import { createSelector, createSlice } from '@reduxjs/toolkit';
import { getInformationMaterialFlyers, getInformationMaterials } from 'api/InformationMaterials';
import { fetchWithLanguage } from 'store/helpers';

export const fetchInformationMaterials = fetchWithLanguage('fetchInformationMaterials', getInformationMaterials);
export const fetchInformationMaterialsFlyers = fetchWithLanguage(
    'fetchInformationMaterialsFlyers',
    getInformationMaterialFlyers,
);

const informationMaterialsSlice = createSlice({
    name: 'InformationMaterialsSlice',
    initialState: {
        informationMaterials: {},
        informationMaterialFlyers: {},
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchInformationMaterials.fulfilled, (state, action) => {
                state.informationMaterials = action.payload;
                const test = action.payload.data.catalogs
                    .filter(catalog => catalog.has_flyers)
                    .reduce(
                        (prev, catalog) => ({
                            ...prev,
                            [catalog.id]: {
                                flyers: [],
                                next: false,
                            },
                        }),
                        {},
                    );
                state.informationMaterialFlyers = test;
            })
            .addCase(fetchInformationMaterialsFlyers.fulfilled, (state, action) => {
                const { payload, meta } = action;

                if (meta.arg.page === 1) {
                    state.informationMaterialFlyers[meta.arg.id] = {
                        flyers: payload.data,
                        page: meta.arg.page,
                        next: payload.next,
                    };
                } else {
                    state.informationMaterialFlyers[meta.arg.id] = {
                        flyers: [...state.informationMaterialFlyers[meta.arg.id].flyers, ...payload.data],
                        page: meta.arg.page,
                        next: payload.next,
                    };
                }
            });
    },
});

export const selectInformationMaterialsPage = createSelector(
    [state => state.informationMaterialsState.informationMaterials],
    informationMaterials => informationMaterials.data || {},
);

export const selectInformationMaterialFlyers = createSelector(
    [state => state.informationMaterialsState.informationMaterialFlyers],
    informationMaterialFlyers => informationMaterialFlyers || {},
);

export default informationMaterialsSlice.reducer;
